import React from "react";
import { useState } from "react";




import { useParams } from "react-router-dom";
import "../assets/jobdetail.css";

const JobDetail = () => {

    const [showApply, setShowApply] = useState(false);
    const { id } = useParams();

    // Later this will come from API
    const job = {
        title: "Business Developement Associate (BDA)",
        location: "Pune, Maharashtra, India",
        experience: "1-2 Years",
        type: "Full Time Employee",
        updated: "21-01-2026",
        department: "Sales & Growth",
        description: `
      The Business Development Associate (BDA) is responsible for initiating contact with prospective clients, understanding their needs, qualifying their intent, and setting the foundation for meaningful relationships.
    `,
    };

    return (
        <div className="job_detail_wrapper">
            {/* Top Header */}
            <div className="job_detail_hero">
                <h1>{job.title}</h1>
                <div className="job_detail_meta">
                    <span>📍 {job.location}</span>
                    <span>🕒 {job.experience}</span>
                    <span>💼 {job.type}</span>
                </div>
                <button
                    className="job_detail_apply_btn"
                    onClick={() => setShowApply(true)}
                >
                    Apply Now
                </button>


            </div>

            <div className="job_detail_body">
                {/* Left Content */}
                <div className="job_detail_content">
                    <h3>Job Description</h3>
                    <div className="job_detail_desc_block">


                        <p>
                            The Business Development Associate (BDA) is responsible for initiating
                            contact with prospective clients, understanding their needs, qualifying
                            their intent, and setting the foundation for meaningful relationships.
                        </p>

                        <p>
                            You will be the bridge between interest and experience—turning inquiries
                            into site visits and conversations into opportunities.
                        </p>

                        <p>
                            This role is the entry point into Samriddhi’s Sales Leadership Track.
                        </p>

                        <p className="job_detail_growth_title">High performers grow into:</p>
                        <ul>
                            <li>Relationship Executive</li>
                            <li>Senior Relationship Manager</li>
                            <li>Sales Lead / Project Head</li>
                        </ul>

                        <h4>Key Responsibilities</h4>
                        <ul>
                            <li>Make first contact with incoming leads (calls, WhatsApp, forms)</li>
                            <li>Understand client intent: budget, need, timeline, location preference</li>
                            <li>Educate clients about Samriddhi’s philosophy and projects</li>
                            <li>Qualify leads and schedule site visits for the sales team</li>
                            <li>Maintain accurate updates in CRM</li>
                            <li>Ensure timely and respectful follow-ups</li>
                            <li>Build trust and curiosity, not pressure</li>
                            <li>Coordinate with Relationship Executives for handover</li>
                            <li>Maintain daily call and activity reports</li>
                        </ul>

                        <p className="job_detail_emphasis">
                            You are responsible for keeping the lifeline of every lead alive.
                        </p>

                        <h4>Required Skills</h4>
                        <ul>
                            <li>Clear and confident communication in Marathi, Hindi & English</li>
                            <li>Ability to listen and understand before speaking</li>
                            <li>Basic understanding of sales and customer psychology</li>
                            <li>Comfortable speaking with new people daily</li>
                            <li>Discipline in follow-ups and data handling</li>
                            <li>Emotional maturity to handle rejection calmly</li>
                            <li>Willingness to learn and grow</li>
                        </ul>

                        <h4>Preferred (Good-to-Have) Skills</h4>
                        <ul>
                            <li>MBA / Graduate in Business, Marketing, or Communication</li>
                            <li>Experience in inside sales, tele-sales, or customer engagement</li>
                            <li>Familiarity with CRM tools</li>
                            <li>Interest in real estate, lifestyle, or premium products</li>
                            <li>Positive attitude and growth mindset</li>
                            <li>Ability to build rapport quickly</li>
                        </ul>
                    </div>

                </div>

                {/* Right Sidebar */}
                <aside className="job_detail_sidebar">
                    <h4>Job Snapshot</h4>
                    <ul>
                        <li><strong>Updated:</strong> {job.updated}</li>
                        {/* <li><strong>Department:</strong> {job.department}</li> */}
                        <li><strong>Location:</strong> {job.location}</li>
                        <li><strong>Experience:</strong> {job.experience}</li>
                        <li><strong>Type:</strong> {job.type}</li>
                    </ul>
                </aside>
            </div>



            {/* ---------------------------MOdal--------------------------- */}

            {showApply && (
                <div className="job_apply_modal_overlay">
                    <div className="job_apply_modal">

                        <button
                            className="job_apply_close"
                            onClick={() => setShowApply(false)}
                        >
                            ×
                        </button>

                        <h3 className="job_apply_title">Apply to Join us</h3>

                        <div className="job_apply_block">
                            <label className="job_apply_label">
                                What excites you about building at Samriddhi?
                            </label>
                            <textarea
                                className="job_apply_textarea"
                                placeholder="Tell us what draws you to Samriddhi and this role..."
                                rows="4"
                            />
                        </div>

                        <div className="job_apply_grid">
                            <input className="job_apply_input" placeholder="Full Name" />
                            <input className="job_apply_input" placeholder="Email Address" />
                            <input className="job_apply_input" placeholder="Phone Number" />
                            <input className="job_apply_input" placeholder="Current City" />
                        </div>

                        <div className="job_apply_file">
                            <label>Upload Your CV</label>
                            <input type="file" />
                        </div>

                        <button className="job_apply_submit">Submit Application</button>
                    </div>
                </div>
            )}



        </div>
    );
};

export default JobDetail;
